module.exports = __webpack_public_path__ + "static/media/18493491_461669817512283_315258570_o.965237a6.jpg";